import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { NumberPickerComponent } from '../number-picker/number-picker.component';
import { MdSnackBar } from '@angular/material';
@Component({
  selector: 'app-miniature-list',
  templateUrl: './miniature-list.component.html',
  styleUrls: ['./miniature-list.component.less']
})
export class MiniatureListComponent implements OnInit {

  @Input() tag: string;
  @Input() model: Object;
  detailSteps = ['Basic', 'Advanced', 'Pro', 'Epic'];

  constructor(public snackBar: MdSnackBar) {

  }

  ngOnInit() {
    if (!this.model[this.tag]) {
      let map = new Object();
      this.detailSteps.forEach((step: string) => { map[step]= new Array<string>(); });
      this.model[this.tag] = map;
    }
  }

  onCountChanged(count: number, detail: string) {
    let arr = this.model[this.tag][detail];
    if (arr.length < count) {
      for (let i = arr.length; i < count; i++) {
        arr.push('');
      }
    } else {
      let toDelete = arr.length - count;
      for (let i = arr.length - 1; i >= 0; i--) {
        if (arr[i] == undefined || arr[i].trim().length < 1) {
          arr.splice(i, 1);
          toDelete--;
        }
        if (toDelete < 1) break;
      }
    }
  }
  trackIndex(index: number, value: number): number { return index; }
  getMin(detail: string) {
    return this.model[this.tag][detail].filter((str) => { return str.trim().length > 0; }).length;
  }

  copyFromPrevious(index: number, detail: string) {
    if (index < 1) return;
    this.model[this.tag][detail][index] = this.model[this.tag][detail][index - 1];
  }
  delete(index: number, detail: string, numberPicker: any) {
    if (index < 0 || index > 99) return;
    this.model[this.tag][detail][index] = '';
    setTimeout(() => {
      (numberPicker as NumberPickerComponent).decreaseValue();
    }, 0);
  }

  onCountChangeFailed(eventData: any, numberPicker: ElementRef) {
    let message = '';
    if (eventData.failedMax) {
      message = 'Es sind nur je ' + eventData.max + ' Modelle erlaubt.';
    } else if (eventData.failedMin) {
      if (eventData.min > 0) {
        message = 'Bitte manuell löschen! Alle felder sind ausgefüllt!';
      } else return;
    }
    this.snackBar.open(message, "OK", {
      duration: 4000,
    });

  }
}



// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/src/app/content/contact/miniature-list/miniature-list.component.ts